import React from "react";
import '../../css/components/Loader/Loader.css';

const Loader = () => {
   return (
      <div className="lds-ring loader"><div></div><div></div><div></div><div></div></div>
   )
}

export default Loader
